export const LEGAL_ADULT_AGE = 18;